var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewEmailChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.721,
    height: 25.212,
    viewBox: "0 0 24.721 25.212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M0-682.665H24.721v24.721H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1200",
    "data-name": "Rectangle 1200",
    width: 24,
    height: 24,
    transform: "translate(0.569 1.212)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g15",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25",
    transform: "translate(0.966 4.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "M-503.739-411.215H-518.8a3.863,3.863,0,0,1-3.863-3.863V-422.8a3.863,3.863,0,0,1,3.863-3.863h15.064a3.863,3.863,0,0,1,3.863,3.863v7.725A3.863,3.863,0,0,1-503.739-411.215Z",
    transform: "translate(522.665 426.666)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g29",
    transform: "translate(4.877 8.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "M-400.935,0l-6.3,5.354a1.923,1.923,0,0,1-1.227.44,1.923,1.923,0,0,1-1.227-.44L-416,0",
    transform: "translate(415.999)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(8.532 0.772)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 3.326,
    cy: 3.326,
    rx: 3.326,
    ry: 3.326,
    transform: "translate(0.502 0.502)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M245.793,0a3.828,3.828,0,1,0,3.829,3.829A3.833,3.833,0,0,0,245.793,0Zm0,6.806a2.978,2.978,0,1,1,2.978-2.978A2.981,2.981,0,0,1,245.793,6.806Zm0,0",
    transform: "translate(-241.965)",
    fill: "#1bb21b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M307.94,96.229l-.975-.975-.6.6,1.577,1.577L310.368,95l-.6-.6Zm0,0",
    transform: "translate(-304.537 -91.725)",
    fill: "#1bb21b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEmailChecked);
export default __webpack_public_path__ + "static/media/view-email-checked.5c22136bb8047550e3f98100c97dccdf.svg";
export { ForwardRef as ReactComponent };